import apiClient from './apiClient';

// Ported 1:1 from the old frontend utils/alerts.js buildAlerts(), verified
// against real production data — see ai-agent-implementation-plan.md Phase 0.
export const getAlerts = () => apiClient.get('/alerts/').then(r => r.data);
